<main>
  <loader></loader>

  <app-menu *ngIf="isShowMenu()"></app-menu>

  <router-outlet></router-outlet>
</main>

<app-dialog></app-dialog>
